import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import type { OrpcClient } from '@/orpc/client'
import { logError } from '@/utils/errorUtils'
import { useOrpc } from './useClient'

export type RemoveOrgMemberInput = Parameters<OrpcClient['removeOrgMember']>[0]

export function useRemoveOrgMember() {
  const orpc = useOrpc()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.removeOrgMember.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: orpc.listPractitioners.key() })
      },
      onError: (error) => {
        logError('super', 'Failed to remove organization member', error)
        showNotification({
          color: 'red',
          title: 'Removal failed',
          message: error instanceof Error ? error.message : 'Unknown error',
        })
      },
    }),
  )
}
